<div class="spinner-container" *ngIf="this.loadingService.loading$ | async">
  <mat-spinner></mat-spinner>
</div>